/* eslint-disable no-unused-vars */
import { useEffect, RefObject, useCallback } from 'react';

const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: MouseEvent | TouchEvent) => void,
) => {
  const listener = useCallback((event: MouseEvent | TouchEvent) => {
    if (!ref.current || ref.current.contains(event.target as Node)) {
      return;
    }

    handler(event);
  }, [ref, handler]);

  useEffect(() => {
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [listener]);

  return listener;
};

export default useOnClickOutside;
